var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 83,
    height: 81,
    viewBox: "0 0 83 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_50_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_54_",
    d: "M72.3737 32.1229H15.584V8.99634H72.3737L82.6122 20.5596L72.3737 32.1229Z",
    fill: "#262D40"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_53_",
    d: "M10.6291 36.5985H67.4188V59.7251H10.6291L0.390625 48.1618L10.6291 36.5985Z",
    fill: "#262D40"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_51_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_52_",
    d: "M45.1852 80.9959V4.42293C45.1852 2.15842 43.3705 0.326416 41.1365 0.326416C38.8985 0.326416 37.0879 2.1625 37.0879 4.42293V81H45.1852V80.9959Z",
    fill: "#262D40"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.bc602848db03de809f77fb5d965391cd.svg";
export { ForwardRef as ReactComponent };